import { Fancybox } from "@fancyapps/ui";

const fancyboxParams = {
    Toolbar: {
        display: {
            right: ["thumbs", "close"],
        }
    }
}

Fancybox.bind("[data-fancybox]", fancyboxParams);

const fancyButtons = document.querySelectorAll('.slider__thumbnail');
fancyButtons.forEach(fancyButton => {
    fancyButton.addEventListener('click', (e) => {
        const parentSlider = fancyButton.closest('.slider') as HTMLElement;
        if (parentSlider) {
            const firstFancyLink = parentSlider.querySelector('.fancy__link') as HTMLElement;
            if (firstFancyLink) {
                firstFancyLink.click();
            }
        }
    })
})